import { FuelType } from "../../../models/vehicle/fuelType";
import { FuelEmission } from "../../../store/reportOptionsSlice";

// Avg consumption calculation
export function calculateAvgConsumption(distance: number, fuel: number) {
    return distance === 0 ? null : (fuel / distance) * 100;
}

// Emission calculation from fuel consumed (liters × emission factor = kg CO₂)
export function calculateEmissionsCo2Kg(fuelConsumed: number, fuelType: FuelType, fuelEmissions: FuelEmission[]) {
    const emission = fuelEmissions.find(x => x.fuelType.toString() === FuelType[fuelType]);
    const emissionRating = emission?.emissionFactor ?? -1;

    if (fuelConsumed == null || emissionRating < 0) return null;
    return emissionRating * fuelConsumed;
}

